import { render, staticRenderFns } from "./RecommendProductList.vue?vue&type=template&id=e9c6c7ea&scoped=true&"
import script from "./RecommendProductList.vue?vue&type=script&lang=js&"
export * from "./RecommendProductList.vue?vue&type=script&lang=js&"
import style0 from "./RecommendProductList.vue?vue&type=style&index=0&id=e9c6c7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c6c7ea",
  null
  
)

export default component.exports